import { render, staticRenderFns } from "./BackofficeMateriaisCotados.vue?vue&type=template&id=09d1aa67&scoped=true"
import script from "./BackofficeMateriaisCotados.vue?vue&type=script&lang=ts"
export * from "./BackofficeMateriaisCotados.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeMateriaisCotados.vue?vue&type=style&index=0&id=09d1aa67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d1aa67",
  null
  
)

export default component.exports